// Helper function to calculate performance
const calculatePerformance = (categoryAverage, schoolAverage) => {
  return parseFloat((categoryAverage - schoolAverage).toFixed(2));
};

export default calculatePerformance;
